import SmartphoneIcon from "@mui/icons-material/Smartphone";
import PhoneIcon from "@mui/icons-material/Phone";
import { Box } from "@mui/material";
import IconInput from "./IconInput";
import { useState } from "react";

export default function Phone(props: any) {
  const { prefix, value, mobile, onChange } = props;

  const [shrink, setShrink] = useState(false);

  function onPhoneChange(e: any) {
    const { value } = e.target;
    if (value === "" || (value.length <= 10 && /^\d+$/.test(value))) {
      onChange(e);
    }
  }

  function handleOnFocus(e: any) {
    setShrink(true);
  }

  function handleOnBlur(e: any) {
    setShrink(!!e.target.value);
  }
  return (
    <IconInput
      {...props}
      onFocus={handleOnFocus}
      onBlur={handleOnBlur}
      startComponent={
        <Box display={"flex"} color={"gray"}>
          {mobile ? <SmartphoneIcon /> : <PhoneIcon />}
          {(shrink || value) && prefix}
        </Box>
      }
      onChange={onPhoneChange}
    />
  );
}
